<div>
	<div class="quantity-wrapper">
		<button (click)="decrement()" class="left">–</button>

		<input
			#quantityInputCart
			type="number"
			[value]="quantity"
			(change)="onInputChange($event)"
			[min]="minOrderQuantity"
		/>
		<button (click)="increment()" class="right">+</button>
	</div>
	<p *ngIf="showMinOrderQuantityMessage" class="fb-warn text-[10px] md:text-[12px] font-semibold">Minimum order quantity is {{minOrderQuantity}} {{unit.toLowerCase()}}(s)</p>
	<p *ngIf="showMaxOrderQuantityMessage" class="fb-warn text-[10px] md:text-[12px] font-semibold">Maximum quantity available is {{calculatedQuantityInStock}} {{unit.toLowerCase()}}(s)</p>
</div>

